import React from "react";
import styled from "styled-components";

const Title = styled.h2`
  font-family: 'Geist Variable', 'Geist', sans-serif;
  font-weight: 600;
  font-size: clamp(22px, 3.5vw, 28px);
  color: oklch(.145 0 0);
  margin: 0 0 14px 0;
`;

const ActionsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const ActionCard = styled.div`
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #ffffff;
  padding: 14px;
`;

const ActionTitle = styled.div`
  font-weight: 600;
  color: oklch(.145 0 0);
`;
const ActionDesc = styled.p`
  color: #4b5563;
  margin: 6px 0 0 0;
`;

const SmallLabel = styled.div`
  font-size: 12px;
  color: #6b7280;
`;

function formatDateYYYYMMDD(dateObj) {
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

function addDays(base, days) {
  const d = new Date(base.getTime());
  d.setDate(d.getDate() + days);
  return d;
}

function addMonths(base, months) {
  const d = new Date(base.getTime());
  d.setMonth(d.getMonth() + months);
  return d;
}

function getTimeframeLabel(dateStr) {
  if (!dateStr) return '';
  const today = new Date();
  const d2w = formatDateYYYYMMDD(addDays(today, 14));
  const d1m = formatDateYYYYMMDD(addMonths(today, 1));
  const d2m = formatDateYYYYMMDD(addMonths(today, 2));
  const d3m = formatDateYYYYMMDD(addMonths(today, 3));
  if (dateStr === d2w) return '2 weeks';
  if (dateStr === d1m) return '1 month';
  if (dateStr === d2m) return '2 months';
  if (dateStr === d3m) return '3 months';
  return dateStr;
}

export default function ReviewConfirm({
  actions,
}) {
  return (
    <div>
      <Title>Review Your Action Plan</Title>
      <ActionsList>
        {actions.map((a, i) => (
          <ActionCard key={a.id}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', gap: 10 }}>
              <div style={{ fontWeight: 600, color: 'oklch(.145 0 0)' }}>Action {i + 1}</div>
            </div>
            <div style={{ marginTop: 6 }}>
              <ActionTitle>{a.title || 'Untitled action'}</ActionTitle>
              {a.description ? <ActionDesc>{a.description}</ActionDesc> : null}
              {a.date ? <SmallLabel>Timeline: {getTimeframeLabel(a.date)}</SmallLabel> : null}
            </div>
          </ActionCard>
        ))}
      </ActionsList>
    </div>
  );
}

